const feathers = require('@feathersjs/client');
const io = require('socket.io-client');
import UserService from './UserService';
const serviceUrl = process.env.VUE_APP_SOCKET_URL+':'+process.env.VUE_APP_SOCKET_PORT;

const socket = io(serviceUrl);

const client = feathers();

client.configure(feathers.socketio(socket, {timeout:60000}));

const dictionaryService = client.service('umatibet');

const monlamEnglishToTibetanService = client.service('monlam/english-to-tibetan');
const monlamTibetanToEnglishService = client.service('monlam/tibetan-to-english');
const monlamTibetanToTibetanOldService = client.service('monlam/tibetan-to-tibetan');
const monlamGrandDic = client.service('monlam/grand-dictionary');

const apiUrl = `${process.env.VUE_APP_SOCKET_URL}:${process.env.VUE_APP_SOCKET_PORT}`;

const userService = new UserService(client);

// eslint-disable-next-line no-console
console.log(`apiUrl="${apiUrl}"`);

export {
    dictionaryService,
    monlamEnglishToTibetanService,
    monlamTibetanToEnglishService,
    monlamTibetanToTibetanOldService,
    monlamGrandDic,
    apiUrl,
    userService,
    socket
}
